const ServicioAsignacionValoresObjetos = {

  asignarAtributosObjeto(event, _this, toUpperCase) {
    let nombrePropiedad = event.target.name;
    let valorPropiedad = event.target.value;
    if (toUpperCase) {
      if (valorPropiedad && typeof valorPropiedad !== 'object'){
        valorPropiedad = valorPropiedad.toUpperCase();
      //  valorPropiedad = valorPropiedad.normalize('NFD').replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi,"$1$2").normalize();
      }
    }

    let nombreObjetoState = nombrePropiedad.split(".")[0];
    let nombreAtributoObjetoState = nombrePropiedad.split(".")[1];
    let objeto = _this.state[nombreObjetoState];
    objeto[nombreAtributoObjetoState] = valorPropiedad;
    _this.setState({ objeto });
  },

  esObjetoVacio(objeto) {     
    if (objeto === undefined)
      return true;
      
    if (objeto === null)
      return true;
      
    if (objeto.length > 0)      
      return false;
      
    if (objeto.length === 0)
      return true;
          
    if (objeto === true)
      return false;    
      
    if (Object.keys(objeto).length > 0)
      return false;
    

    if (JSON.stringify(objeto) === JSON.stringify({}))
      return true;
      
    for (var key in objeto) {
      if (hasOwnProperty.call(objeto, key))
        return false;              
    }
    if (typeof objeto === 'number')
      return false;
          
    if (JSON.stringify(objeto).length > 0)
        return false; 
    return true;
  },
  eliminarObjetoMapa(arreglo,elemento){
    const indice = arreglo.indexOf(elemento);
    arreglo.splice(indice, 1);
},
eliminarObjetoColeccion(arreglo, elemento) {
  const indice = arreglo.indexOf(elemento);
  arreglo.splice(indice, 1);
}
}

export default ServicioAsignacionValoresObjetos;